"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('module-avatar', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 56C40.0301 56 47.1391 52.0563 51.4958 46C47.1391 39.9437 40.0301 36 32 36C23.9699 36 16.8609 39.9437 12.5042 46C16.8609 52.0563 23.9699 56 32 56Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M51.4958 46C47.1391 39.9437 40.0301 36 32 36C23.9699 36 16.8609 39.9437 12.5042 46M51.4958 46C54.3305 42.0595 56 37.2247 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 37.2247 9.66952 42.0595 12.5042 46M51.4958 46C47.1391 52.0563 40.0301 56 32 56C23.9699 56 16.8609 52.0563 12.5042 46",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    cx: "32",
    cy: "22",
    r: "6",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;